import React, { useEffect, useState } from "react";

import { FiMenu } from "react-icons/fi";
import { IoIosMail, IoMdCall } from "react-icons/io";

import { Flex } from "../ui-component/Flex/Flex";
import { Container } from "../common/Container/Container";
import { NavBar } from "../NavBar/NavBar";
import { LanguageBar } from "../LanguageBar/LanguageBar";
import { useToggle } from "../../hooks/useToggle.js";
import { MobileMenu } from "../NavBar/MobileMenu/MobileMenu";

import {
	StyledHeader,
	StyledItemContact,
	StyledListContacts,
	DropMenuWrapper,
} from "./Header.styled.js";

export const Header = () => {
	const [sticky, setSticky] = useState(false);
	const { isOpen, toggle } = useToggle();

	/* ---------------- функцыя отображения тени ниже 80 пикселей ---------------- */
	useEffect(() => {
		const handleScroll = () => {
			setSticky(window.scrollY >= 80);
		};
		window.addEventListener("scroll", handleScroll);

		return () => {
			window.addEventListener("scroll", handleScroll);
		};
	});

	return (
		<StyledHeader scroll={window.scrollY} shadow={(p) => p.theme.shadow}>
			<Container header>
				<Flex
					mobileJustify="space-between"
					mobileAlign="center"
					justify="space-between"
					align="center">
					<NavBar display="none" isOpen={isOpen} />
					<LanguageBar display="none" />
					<StyledListContacts>
						<StyledItemContact margin="0 0 10px 0">
							<Flex align="center">
								<span>
									<IoIosMail size="24px" />
								</span>
								<a href="mailto:presbetons@gmail.com">
									presbetons@gmail.com
								</a>
							</Flex>
						</StyledItemContact>
						<Flex align="center">
							<StyledItemContact margin="0 10px 0 0">
								<Flex align="center">
									<span>
										<IoMdCall size="24px" />
									</span>
									<a href="tel:+380673228999">
										(067) 322-89-99
									</a>
								</Flex>
							</StyledItemContact>
							<StyledItemContact>
								<Flex align="center">
									<span>
										<IoMdCall size="24px" />
									</span>
									<a href="tel:+380673228999">
										(067) 404-62-69
									</a>
								</Flex>
							</StyledItemContact>
						</Flex>
					</StyledListContacts>
					{isOpen ? (
						<MobileMenu toggle={toggle} />
					) : (
						<DropMenuWrapper>
							<FiMenu size={"2em"} onClick={toggle} />
						</DropMenuWrapper>
					)}
				</Flex>
			</Container>
		</StyledHeader>
	);
};
